import { render, staticRenderFns } from "./EquipamentoEditForm.vue?vue&type=template&id=149601ba&scoped=true&"
import script from "./EquipamentoEditForm.vue?vue&type=script&lang=js&"
export * from "./EquipamentoEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149601ba",
  null
  
)

export default component.exports